// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__bUxXm","tab":"ProcedureTabs_tab__2ilWK"};